import _ from "lodash";
import { v4 as uuidv4 } from 'uuid';
import { Types } from "../actions/costCenterActions";

//import { v4 as uuidv4 } from 'uuid';

const defaultState = {
  costCenter: {}
};

const costCenterReducers = (state = defaultState, action) => {
  switch (action.type) {
    case Types.COSTCENTER_GET_LIST: {

      let newState = _.cloneDeep(state);

      console.log('action',action)
      newState.costCenter.costCenterList = _.sortBy(action.payload.costCenters,'costCenterName');

      return newState;
    }
    case Types.COSTCENTER_UPDATE: {

      let newState = _.cloneDeep(state);

      newState.costCenter.costCenterList = [...newState.costCenter.costCenterList]

      let {id,field,value} = action.update

      const costCenterIndex = newState.costCenter.costCenterList.findIndex(costCenter => costCenter.id == id);

      if (costCenterIndex !== -1){
        newState.costCenter.costCenterList[costCenterIndex][field] = value
        newState.costCenter.costCenterList[costCenterIndex].updated = true
      } else {
        newState.costCenter.costCenterList.push({
          id: id,
          [field] : value,
          new: true
        })
      }

      return newState;
    }
    case Types.COSTCENTER_ADD: {

      let newState = _.cloneDeep(state);

      newState.costCenter.costCenterList = [...newState.costCenter.costCenterList]

      let parent = action.parent

      newState.costCenter.costCenterList.push({
        id: uuidv4(),
        parent,
        new: true
      })

      return newState;
    }
    case Types.COSTCENTER_REMOVE: {

      let newState = _.cloneDeep(state);

      let id = action.id

      newState.costCenter.costCenterList = newState.costCenter.costCenterList.filter(costCenter => costCenter.id != id)

      return newState;
    }
    case Types.COSTCENTER_SAVE: {

      let newState = _.cloneDeep(state);

      let {costCenters} = action.payload

      console.log('saved',costCenters,newState.costCenter.costCenterList)
      // newState.costCenter.costCenterList = newState.costCenter.costCenterList.filter(costCenter => costCenter.id != id)

      return newState;
    }
    default:
      return state;
  }
};

export default costCenterReducers;